module.exports = __webpack_public_path__ + "static/img/nav1.ac7efae3.svg";